// extracted by mini-css-extract-plugin
export default {"root":"ChecksList_root__paVPR","root_nothing":"ChecksList_root_nothing__QrGv4"};